<template>
  <div>
    <b-form-group
      v-if="target?.fieldOrigin"
      label="Field Origin"
    >
      <b-form-input
        :value="target.fieldOrigin"
        disabled
      />
    </b-form-group>
    
    <b-form-group label="Field Name">
      <b-form-input
        v-model="inputFields.name"
        placeholder="Enter field name"
        trim
        @input="onChangeValue('name')"
      />
    </b-form-group>

    <b-form-group
      v-show="inputFields.isShowAngle"
      label="Angle"
    >
      <b-form-input
        v-model.number="inputFields.angle"
        type="number"
        placeholder="Enter angle"
        :disabled="isTransformDisabled"
        @change="onChangeValue('angle')"
      />
    </b-form-group>

    <b-form-group label="Link">
      <b-form-input
        v-model="inputFields.link"
        placeholder="Enter link"
        trim
        @change="onChangeValue('link')"
      />
    </b-form-group>
    <b-form-group
      v-if="!!inputFields.notes"
      label="Notes"
    >
      <b-form-input
        v-model="inputFields.notes"
        trim
        disabled
        @change="onChangeValue('link')"
      />
    </b-form-group>
    <div class="position-fixed apply-to-field-dropdwon-section">
      <b-form-group
        label="Apply Field Name to:"
        label-cols="6"
      >
        <div class="d-flex align-items-center gap-2">
          <SelectTemplateDropdown
            v-if="target?.canvas"
            :current-instance-id="target.canvas.instance_id"
            :local-storage-key="localStorageKey"
            :clear-local-storage="true"
          />
          <b-button
            variant="primary"
            size="sm"
            @click="onClickApplyTo"
          >
            Apply
          </b-button>
        </div>
      </b-form-group>
    </div>

    <b-form-group
      label="Apply Angle to:"
      label-cols="12"
    >
      <b-button
        variant="primary"
        size="sm"
        @click="applyToProducts"
      >
        All Products
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import { editorControlEventBroker, EVENTS as EDITOR_CONTROL_EVENTS } from '../../../../group/modules/editor-control-popup/event-broker';
import { propertiesModuleEventBroker, EVENTS } from '../../../../services/EditorControls/properties-module/event-broker';
import SelectTemplateDropdown
  from "@frontend/components/modules/layouts-page/EditorControl/components/SelectTemplateDropdown.vue";
import selectedTemplateForApplyToAll, { LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_RENAME_FIELD} from "@frontend/group/modules/editor-control-popup/selected-template-for-apply-to-all";
import { editModeService } from "@frontend/services/EditModeService";

const {getSelectedTempaltes} = selectedTemplateForApplyToAll;

export default {
  name: 'PropertiesModule',
  components: {SelectTemplateDropdown},
  props: {
    target: {
      type: Object,
      require: true,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inputFields: {
        fieldId: null,
        name: '',
        link: '',
        angle: 0,
        isShowAngle: true,
        notes: '',
      },
      localStorageKey: LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_RENAME_FIELD
    };
  },
  computed: {
    isTransformDisabled() {
      return !editModeService.allowsStructuralChanges(this.target);
    },
  },
  watch: {
    options (newVal) {
      this.init(newVal)
    },
    'target.angle'(v) {
      this.inputFields.angle = v
    },
    'target.templateField.name'(v) {
      if (typeof v === 'undefined') return;
      this.inputFields.name = v
    }
  },
  mounted() {
    if (this.options && Object.keys(this.options).length) {
      this.init(this.options);
    } else {
      if (!propertiesModuleEventBroker.isListen(EVENTS.INIT)) {
        propertiesModuleEventBroker.on(EVENTS.INIT, this.init.bind(this));
      }
    }
  },
  methods: {
    init(dto) {
      for (const key in dto) {
        this.$set(this.inputFields, key, dto[key]);
      }
    },
    onChangeValue(action) {
      const payload = {
        ...this.inputFields,
        angle: Number(this.inputFields.angle)
      };
      
      propertiesModuleEventBroker.fire(EVENTS.CHANGED, {
        action, 
        ...payload
      });

      editorControlEventBroker.fire(EDITOR_CONTROL_EVENTS.PROPERTIES_MODULE_CHANGED, {
        action, 
        ...payload
      })
    },
    onClickApplyTo() {
      editorControlEventBroker.fire(EDITOR_CONTROL_EVENTS.APPLY_TO_PROPERTIES, {
        action: 'apply_name_to',
        ...{...this.inputFields, templates: getSelectedTempaltes(this.localStorageKey), oldName: this.options.name}
      })
    },

    applyToProducts() {
      editorControlEventBroker.fire(EDITOR_CONTROL_EVENTS.PRODUCTS_ANGLE_CHANGED, {
        angle: Number(this.inputFields.angle)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .apply-to-field-dropdwon-section{
   bottom: 44px;
   z-index: 999;
 }
</style>
